import {
  SCROLL_TO_RESULTADO_ID,
  ScrollableFieldsConfig,
} from '@mchat-rf/consulta-seguimento/hooks/useConsultaSeguimentoAutoScroll'
import { SimNaoEnum } from 'components/form'
import { isEmpty } from 'util/checks'

import { ConsultaSeguimentoPergunta16Model } from './model-consultaSeguimentoPergunta16'
import {
  hasPergunta16ExemplosFalhouAnySim,
  hasPergunta16ExemplosPassouAnySim,
  isPergunta16ExemplosAllFilled,
  isPergunta16ExemplosAllNao,
} from './utils-consultaSeguimentoPergunta16'

export const PERGUNTA_16_SCROLL_CONFIG: ScrollableFieldsConfig<ConsultaSeguimentoPergunta16Model> = {
  PERGUNTA_16_HEADER: {
    scrollConditions: [
      {
        if: (value) => value === SimNaoEnum.SIM,
        scrollTo: SCROLL_TO_RESULTADO_ID,
      },
      {
        if: (value) => value === SimNaoEnum.NAO,
        scrollTo: 'PERGUNTA_16_EXEMPLOS',
      },
    ],
  },
  PERGUNTA_16_EXEMPLOS: {
    scrollConditions: [
      {
        if: (value) => isPergunta16ExemplosAllNao(value),
        scrollTo: 'BOTTOM',
      },
      {
        if: (value) =>
          isPergunta16ExemplosAllFilled(value) &&
          hasPergunta16ExemplosPassouAnySim(value) &&
          hasPergunta16ExemplosFalhouAnySim(value),
        scrollTo: 'PERGUNTA_16_FREQUENCIA',
      },
      {
        if: (value) =>
          isPergunta16ExemplosAllFilled(value) &&
          hasPergunta16ExemplosPassouAnySim(value) &&
          !hasPergunta16ExemplosFalhouAnySim(value),
        scrollTo: SCROLL_TO_RESULTADO_ID,
      },
      {
        if: (value) =>
          isPergunta16ExemplosAllFilled(value) &&
          hasPergunta16ExemplosFalhouAnySim(value) &&
          !hasPergunta16ExemplosPassouAnySim(value),
        scrollTo: SCROLL_TO_RESULTADO_ID,
      },
    ],
    isList: true,
    dependsOn: 'PERGUNTA_16_HEADER',
  },
  PERGUNTA_16_FREQUENCIA: {
    scrollConditions: [
      {
        if: (value) => !isEmpty(value),
        scrollTo: SCROLL_TO_RESULTADO_ID,
      },
    ],
    dependsOn: 'PERGUNTA_16_EXEMPLOS',
  },
}
